import { Navigate, Outlet } from "react-router";
import { getRoleHomePath } from "modules/auth/utils";
import { useAuth } from "modules/auth/useAuth";
import { PageLoadingFallback } from "shared/ui/PageLoadingFallback";

export function GuestOnly() {
  const { isAuthenticated, isRestoring, user } = useAuth();

  if (isRestoring) {
    return <PageLoadingFallback minHeight="100vh" />;
  }

  if (isAuthenticated && user) {
    return <Navigate to={getRoleHomePath(user.role)} replace />;
  }

  return <Outlet />;
}
